import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://rjmfptdkxkbwsiesudzk.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJqbWZwdGRreGtid3NpZXN1ZHprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE1MjY0OTQsImV4cCI6MjA3NzEwMjQ5NH0.LnozVoKrYoslGfpy5nhVkorDYHbzZ1J2xRrZBJNZG0c'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})